const isFileGif = path => (path || '').toLowerCase().split('.').pop() === 'gif';

export default isFileGif;
